
<template>
  <!-- Food Menu Start -->
  <section class="food_menu_area">
    <img
      v-for="(item, key) in foodMenuAreaImages"
      v-bind:src="item.img"
      v-bind:alt="item.altText"
      v-bind:class="item.cssClass"
      :key="key"
    />
    <div class="container">
      <div class="row align-items-end">
        <div class="col-lg-4 col-md-12">
          <div class="food_menu_box">
            <div class="food_menu_title">
              <h3>Pizzas</h3>
            </div>
            <br>
            <div class="food_menu_inn">
              <a
                class="food_menu_item"
                href="#"
                target="_self"
                rel=""
                v-for="(item, key) in foodMenus.clasicas"
                :key="key"
              >
                <div class="menu-item_content-wrap">
                  <div class="menu-item_content">
                    <div class="menu-item_title">
                      <h4>{{ item.title }}</h4>
                    </div>
                    <div class="menu-item_price">
                      <h4>
                        <span class="currencySymbol">{{ item.currency }}</span
                        >{{ item.price }}
                      </h4>
                    </div>
                  </div>
                  <div class="menu-item_desc">
                    <p>{{ item.description }}</p>
                  </div>
                </div>
              </a>
              <br>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
         
        </div>
        <div class="col-lg-4 col-md-12">
          <div class="food_menu_box">
            <div class="food_menu_title">
              <h3>Especiales</h3>
            </div>
            </br>
            <div class="food_menu_inn">
              <a
                class="food_menu_item"
                href="#"
                target="_self"
                rel=""
                v-for="(item, key) in foodMenus.especiales"
                :key="key"
              >
                <div class="menu-item_content-wrap">
                  <div class="menu-item_content">
                    <div class="menu-item_title">
                      <h4>{{ item.title }}</h4>
                    </div>
                    <div class="menu-item_price">
                      <h4>
                        <span class="currencySymbol">{{ item.currency }}</span
                        >{{ item.price }}
                      </h4>
                    </div>
                  </div>
                  <div class="menu-item_desc">
                    <p>{{ item.description }}</p>
                  </div>
                </div>
              </a>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Food Menu End -->
</template>
<script>
import { TimelineMax } from "gsap";

export default {
  name: "FoodMenuArea",
  data() {
    return {
      foodMenuAreaImages: [
        {
          img: require("../assets/img/food_menu_pizza.png"),
          altText: "img",
          cssClass: "menu_pizza",
        },
        {
          img: require("../assets/img/food_menu_shape_1.png"),
          altText: "shape",
          cssClass: "food_menu_shape_1",
        },
        {
          img: require("../assets/img/food_menu_shape_2.png"),
          altText: "shape",
          cssClass: "food_menu_shape_2",
        },
        {
          img: require("../assets/img/food_menu_shape_3.png"),
          altText: "shape",
          cssClass: "food_menu_shape_3",
        },
        {
          img: require("../assets/img/food_menu_shape_1.png"),
          altText: "shape",
          cssClass: "food_menu_shape_4",
        },
        {
          img: require("../assets/img/food_menu_shape_1.png"),
          altText: "shape",
          cssClass: "food_menu_shape_5",
        },
      ],
      foodMenus: {
        clasicas: [
          {
            title: "Pizza de Quesos",
            description: "Parmesano y mozzarella",
            currency: "$",
            price: "140 - 240",
          },
          {
            title: "Pepperoni",
            description: "Solo pepperoni",
            currency: "$",
            price: "150 - 250",
          },
          {
            title: "Spicy Pepperoni",
            description: "Pepperoni y jalapeño verde",
            currency: "$",
            price: "160 - 260",
          },
          {
            title: "Pizza de Carnes",
            description: "Pepperoni, tocino y jamón",
            currency: "$",
            price: "180 - 280",
          },
        ],

        especiales: [
          {
            title: "Pizza Campestre",
            description: "Jamón, chile morrón y cebolla",
            currency: "$",
            price: "170 - 270",
          },
          {
            title: "Pizza de Vegetales",
            description: "Jalapeño y champiñones",
            currency: "$",
            price: "150 - 250",
          },
          {
            title: "Sampler",
            description: "Dedos de queso, papas fritas y aros de cebolla",
            currency: "$",
            price: "180",
          },
          {
            title: "Papas Fritas",
            description: "300g de papas fritas",
            currency: "$",
            price: "100",
          },
        ],
      },
    };
  },
  mounted() {
    this.setScene();
  },
  methods: {
    setScene() {
      let self = this;

      // Declare Scene
      const scene = this.$scrollmagic
        .scene(self.sceneElem(".food_menu_area", "100%", "-500"))
        // Declaration of animation and attaching to element
        .setTween(
          self.getTimeLine(".menu_pizza", 1, {
            y: "-500",
            ease: "Linear.easeNone",
          })
        );

      // Add Scene to controller
      this.$scrollmagic.addScene(scene);
    },
    sceneElem(triggerElem, duration, offset) {
      return {
        triggerElement: triggerElem,
        duration: duration,
        offset: offset,
      };
    },
    getTimeLine(triggerElem, duration, edgeObj) {
      return new TimelineMax().from(triggerElem, duration, edgeObj);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FoodMenuArea.vue